"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNetwork = void 0;
const constant_1 = require("../constant");
/**
 *
 * @param network
 * @param defaultNetwork
 * @returns
 */
const parseNetwork = (network, defaultNetwork = constant_1.DEFAULT_NETWORK) => {
    var _a;
    switch ((_a = network === null || network === void 0 ? void 0 : network.toLowerCase) === null || _a === void 0 ? void 0 : _a.call(network)) {
        case "main":
        case "mainnet":
            return constant_1.Network.MainNet;
        case "test":
        case "testnet":
            return constant_1.Network.TestNet;
        case "dev":
        case "devnet":
            return constant_1.Network.DevNet;
        case "local":
        case "localhost":
            return constant_1.Network.LocalHost;
    }
    return defaultNetwork;
};
exports.parseNetwork = parseNetwork;
